module.exports = PropTypes;


//////////////////
// WEBPACK FOOTER
// external "PropTypes"
// module id = 5
// module chunks = 0